import {
  updateVbsDocumentationCache,
  useVbsDocumentationResetReferenceNumberMutation,
  useVbsDocumentationShowQuery,
  useVbsDocumentationPatchMutation,
} from "@/services/backend/vbs/work-orders/api/documentation-api";
import { ReferenceNumberField } from "@/services/backend/documents/components/reference-number-field";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

/**
 * DocumentationReferenceNumberField edits the reference number of a
 * documentation. It reads the documentation from the cache itself.
 */
export function DocumentationReferenceNumberField({
  documentationId,
  disabled = false,
}: {
  documentationId: string;
  disabled?: boolean;
}) {
  const { data: documentation } = useVbsDocumentationShowQuery({
    id: documentationId,
  });
  const patchReferenceNumber = useVbsDocumentationPatchMutation();
  const resetReferenceNumber =
    useVbsDocumentationResetReferenceNumberMutation();

  if (!documentation) {
    return null;
  }

  return (
    <ReferenceNumberField
      data={documentation}
      updateCache={updateVbsDocumentationCache}
      patchMutation={patchReferenceNumber}
      resetMutation={resetReferenceNumber}
      disabled={disabled || isImmutable(documentation)}
    />
  );
}
